import { IsNotEmpty, IsString } from "class-validator";

export class GetCompleteSignUpScreenDataRequest {
    @IsString()
    @IsNotEmpty()
    securityToken: string;
}